import { setConfig } from '@altermaind/core/fetch';
import { KEY_POST_REFRESH_TOKEN } from '@/login/state';
import {
  API_CHECK_CONFIRM_TOKEN_PATH_KEY,
  API_CHECK_INVITATIONS_ACCEPT_PATH_KEY,
} from '@/swagger/constants/slash-keys';

const STATUS_CODE_401 = 401;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function configureFetch(store: any) {
  function tokenGetter(): { token: string; issuedAt: number } {
    return {
      token: sessionStorage.getItem('accessToken') ?? '',
      issuedAt: 0,
    };
  }

  async function shouldRefreshToken(error: Response) {
    if (error.status === STATUS_CODE_401) {
      if (
        error.url?.includes(API_CHECK_CONFIRM_TOKEN_PATH_KEY) ||
        error.url?.includes(API_CHECK_INVITATIONS_ACCEPT_PATH_KEY)
      ) {
        return false;
      }
      return true;
    }
    return false;
  }

  async function tokenRefresher(): Promise<void> {
    store.dispatch({
      type: KEY_POST_REFRESH_TOKEN,
      payload: {},
    });
  }

  setConfig({
    tokenRefresher,
    shouldRefreshToken,
    tokenGetter,
  });
}
